//*Libraries imports
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import { CircularProgress } from "@mui/material";
import { ArrowLeft, Files } from "lucide-react";

//*Component imports
import { ActivityStats } from "./ActivityStats";

type Activity = {
  _id: string;
  name: string;
  index: number;
};

type ActivityListProps = {
  activities: Activity[];
  selectedActivityId?: string;
  checkedActivities: string[];
  onSelectActivity: (activity: Activity) => void;
  onToggleActivity: (id: string, checked: boolean) => void;
  loading: boolean;
  stats: {
    completed: number;
    pending: number;
    overdue: number;
    notStarted: number;
  };
};

export function ActivityList(props: ActivityListProps) {
  if (props.loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <CircularProgress size={30} />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden h-full flex flex-col">
      <div className="p-6 border-b border-gray-100">
        <div className="relative flex items-center justify-center mb-6">
          {/* <div className="absolute left-0 bg-gray-100 p-2 rounded-xl">
            <Files className="size-4 text-gray-400" />
          </div> */}
          <h3 className="font-bold text-gray-800 text-xl">
            Atividades ({props.activities.length})
          </h3>
          {/* <button
            title="Voltar"
            className="absolute right-0 text-gray-400 hover:text-gray-600"
          >
            <ArrowLeft className="size-4" />
          </button> */}
        </div>

        <div className="flex justify-center mb-4">
          <ActivityStats {...props.stats} />
        </div>
      </div>

      <div className="overflow-y-auto flex-1 p-6">
        <ul className="space-y-4">
          {props.activities.map((activity, index) => {
            const isChecked = props.checkedActivities.includes(activity._id);
            const isSelected = props.selectedActivityId === activity._id;

            console.log("Atividade:", activity);

            return (
              <li
                key={activity._id}
                onClick={() =>
                  props.onSelectActivity({ ...activity, index: index + 1 })
                }
                className={cn(
                  "flex items-center gap-4 group cursor-pointer transition-colors",
                )}
              >
                <div onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={isChecked}
                    onCheckedChange={(checked) => {
                      props.onToggleActivity(activity._id, checked as boolean);
                    }}
                    className="size-4 border-gray-400 rounded-md data-[state=checked]:bg-blue-600 data-[state=checked]:text-white data-[state=checked]:border-blue-600"
                  />
                </div>

                <div className="flex items-center gap-4 flex-1">
                  <span
                    className={cn(
                      "text-sm font-medium w-6",
                      isSelected ? "text-blue-600" : "text-gray-500",
                    )}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <div className="h-4 w-[1px] bg-gray-200" />

                  <span
                    className={cn(
                      "text-sm font-medium transition-colors flex-1",
                      isSelected ? "text-blue-600" : "text-gray-600",
                      isChecked && "text-gray-400 line-through",
                    )}
                  >
                    {activity.name}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
